export var SearchType;
(function (SearchType) {
    SearchType["PRODUCT_NAME"] = "PRODUCT_NAME";
    SearchType["INCLUDE_PRODUCT_NAME"] = "INCLUDE_PRODUCT_NAME";
    SearchType["PRODUCT_ID"] = "PRODUCT_ID";
    SearchType["USER_USERNAME"] = "USER_USERNAME";
})(SearchType || (SearchType = {}));
